import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { MessageService, MenuItem } from 'primeng/api';
import { ExcursionServiceService } from '../service/excursion-service.service';
import { DatePipe } from '@angular/common';
//import * as xmljs from 'xml-js';
import * as FileSaver from 'file-saver';
//import * as xlsx from "xlsx";
import * as CryptoJS from 'crypto-js';
//import * as ExcelJS from 'exceljs';
import { environment } from  '../../environments/environment';

@Component({
  selector: 'app-transfer',
  templateUrl: './transfer.component.html',
  styleUrls: ['./transfer.component.css'],
  providers: [MessageService]
})
export class TransferComponent implements OnInit {

  constructor(private toastrService: ToastrService,private excursionServiceService: ExcursionServiceService
    ,private datePipe: DatePipe) { }
  appClient: string = environment.appClient;
  transferlistIndex: number = 0;
  isEdit: boolean = false;
  transferlist:any= [];
  transferlistcopy:any = [];
  expandedRows: any = [];
  remarks_list:any= [];
  emaillist:any = [];
  currencyratelist:any = [];
  driverDutySheetlist:any = [];
  EmailDetails:any = [];
  loading = true;
  popupLoading: boolean = true;
  transferPageIndex: number = 0;
  emailPageIndex: number = 0;
  driverPageIndex: number = 0;
  totalPax: number = 0;
  transferPopupVisible: boolean = false;
  items: MenuItem[] = [];
  activeItem!: MenuItem;
  SupplierType: string = 'Supplier';
  Supplier:string='';
  MoreAction:string = '';
  showPopupPriorTime:boolean = false;
  txtPriorTime:number = 0;
  priorTimeMinValue:number = 0;
  selectedRow_VehicleCategory: string = '';
  selectedRow_VC: number = -1;
  showPopupEmail:boolean = false;
  showPopupDriverDutySheet:boolean = false;
  assignmentidList: any = [];
  //UpdateButtonText:string = '';

  overridecheck:boolean = true;

  tabVehicleCategory:string = '';
  tabVehicleType:any;
  tabStatus:string = '';
  tabConfNo:string = '';
  tabVehicleNo:string = '';
  tabFlightNo:any;
  tabFlightTime:string = '';
  tabPickupLocation:any;
  tabDropoffLocation:any;
  tabUnitSaleValue:number = 0;
  tabUnitSaleValueDiffCurr:number = 0;

  tabTotalSaleValue:number = 0;
  tabUnitCostValue:number = 0;
  tabUnitCostValuebkp:number = 0;
  tabParkingFee:number = 0;
  tabOverrideCostCheck:boolean = false;
  tabTotalCostPrice:number = 0;
  tabTotalCostPricebkp:number = 0;
  tabTotalProfit:number = 0;
  tabTotalProfitPerc:number = 0;

  tabPickupTime:string = '';
  tabStartDateTime:string = '';
  tabEndDateTime:string = '';
  tabCompSupCheck:boolean = false;

  tabRemarks:string = '';
  tabCustomerRemarks:string = '';
  tabSupplierRemarks:string = '';
  tabArrivalRemarks:string = '';
  tabDepartureRemarks:string = '';
  tabSaleCurrCode:string = '';
  tabCostCurrCode:string = '';

  supplierList:any = [];
  selectedsupplier:any;
  filteredSupplier:any;

  DriverList:any = [];
  selectedDriver:any;
  filteredDriver:any;

  VehicleTypeList:any = [];
  selectedVehicleType:any;
  filteredVehicleType:any;

  FlightList:any = [];
  selectedFlightNo:any;
  filteredFlightNo:any;

  pickupDropoffList:any = [];
  selectedPickupLocation:any;
  filteredPickupLocation:any;

  UserList:any = [];
  selectedUser:any;
  filteredUser:any;

  AgentList:any = [];
  selectedAgent:any;
  filteredAgent:any;

  DivisionList:any = [];

  AirportRepList:any = [];
  selectedAirportRep:any;
  filteredAirportRep:any;

  selectedDropoffLocation:any;
  filteredDropoffLocation:any;

  transferlistSingle:any= [];

  sortByFlightlist = [{ 'id': 'ASC', 'value': 'Ascending' }, { 'id': 'DESC', 'value': 'Descending' }];
  supplierTypelist = [
    { 'id': 'Supplier', 'value': 'Supplier' },
    { 'id': 'Own Asset', 'value':'Own Asset'},
    { 'id': 'Airport Rep', 'value':'Airport Rep'}
  ];

  MoreActionlist = [
    {'id':'Driver Duty Sheet','value':'Driver Duty Sheet'},
    {'id':'Send Email to Supplier','value':'Send Email to Supplier'},
    {'id':'Update Prior Time','value':'Update Prior Time'},
    // {'id':'Arrival Report','value':'Arrival Report'}
  ];
  StatusList = [
    {'id': 'Assigned','value':'Assigned'},
    {'id': 'Confirmed','value':'Confirmed'},
    {'id': 'Cancelled','value':'Cancelled'},
    {'id': 'Pending','value':'Pending'}
  ]
  StatusListSearch = [
    {'id': 'ShowAll','value':'Show All'},
    {'id': 'Assigned','value':'Assigned'},
    {'id': 'Confirmed','value':'Confirmed'},
    {'id': 'Cancelled','value':'Cancelled'},
    {'id': 'Pending','value':'Pending'}
  ]
  vehicleCategoryList = [
    {'id': 0, 'value': 'Private'},
    {'id': 1, 'value': 'SIC'}
  ]
  
  serviceTypeList = [
    {'id':0, 'value':'Show All'},
    {'id':1, 'value':'Arrival Transfer'},
    {'id':2, 'value':'Departure Transfer'},
    {'id':3, 'value':'InterHotel Transfer'},
    {'id':4, 'value':'Airport Services'}
  ]

  transferForm = new FormGroup({
    sortby: new FormControl('', Validators.required),
    transferfromdate: new FormControl(new Date(), [Validators.required, Validators.minLength(3)]),
    transfertodate: new FormControl(new Date(), [Validators.required, Validators.minLength(3)]),
    RId:new FormControl('',Validators.required),
    servicetype: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    user:new FormControl('',Validators.required),
    agent:new FormControl('',Validators.required),
    division:new FormControl('',Validators.required),
  });

  transferDetailForm = new FormGroup({
    status: new FormControl('',Validators.required),
    ConfNo: new FormControl('',Validators.required),
    VechicleNo: new FormControl('',Validators.required),
    FlightNo: new FormControl('',Validators.required),
    FlightTime: new FormControl('',Validators.required),
    PickupLocation: new FormControl('',Validators.required),
    DropOffLocation: new FormControl('',Validators.required),
    UnitSaleValue: new FormControl('',Validators.required),
    TotalSaleValue: new FormControl('',Validators.required),
    UnitCostValue: new FormControl('',Validators.required),
    ParkingFee: new FormControl('',Validators.required),
    overridecost: new FormControl('',Validators.required),
    TotalCostPrice: new FormControl('',Validators.required),
    TotalProfit: new FormControl('',Validators.required),
    TotalProfitPer: new FormControl('',Validators.required),
    PickupTime: new FormControl('',Validators.required),
    StartDateTime: new FormControl('',Validators.required),
    EndDateTime: new FormControl('',Validators.required),
    complimentaryfromsupplier: new FormControl('',Validators.required),
  });

  ngOnInit(): void {
    this.loading = false;
    this.transferForm.patchValue({
      servicetype: 0,
      status: "ShowAll",
      division: "ShowAll"
    });
    this.loadTransfer(this.transferForm.value);
  }

  first = 0;
  loadTransfer(data: any){
    this.loading = true; 
    let va = { ...data };
    console.log(va);
    //let mastReq = {'transfertype':'ARRIVAL','transferdate':'26-03-2024','requestid':''}
    this.excursionServiceService.getTransferList(va).subscribe((res: any) => {
      this.loading = false;
      if (res['result'] == 1) {
        this.transferPageIndex = 0;
        this.excursionServiceService.getMasterList().subscribe((resMast: any)=>{
          if(resMast['result'] == 1){
            this.supplierList = resMast['data'][0]['SupplierList'];
            this.VehicleTypeList = resMast['data'][0]['VechileServiceTypeList'];
            this.DriverList = resMast['data'][0]['DriverList'];
            this.UserList = resMast['data'][0]['UserList'];
            this.AgentList = resMast['data'][0]['AgentList'];
            this.DivisionList = resMast['data'][0]['DivisionList'];
            this.AirportRepList = resMast['data'][0]['AirportRepList'];

            this.getPriorTime();
          }
        });

        this.SupplierType = "Supplier";
        //this.UpdateButtonText = "Update Supplier";

        this.first = 0
        this.transferlist = []
        //console.log(res['data']);
        this.transferlist = res['data'];
        this.transferlistcopy = res['data'];
        this.expandedRows = [];
        this.totalPax = this.transferlist.reduce((sum: any, current: any) => sum + (+current.adults) + (+current.child), 0);
      }
      else if(res['result'] == 0){
        var msg = res['errors'];
        this.toastrService.error(msg, 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
    });
  }

  validateToDate(fromdate: string, todate: string) : boolean {
    let dateValidation = false;
    const fDate = new Date(fromdate);
    const tDate = new Date(todate);
    if(fDate > tDate) {
      dateValidation = true;
    }
    return dateValidation;
  }

  transfer_search_FormSubmit(val: boolean){
    this.assignmentidList = [];
    this.transferForm.value['transferfromdate'] = new Date(this.transferForm.value['transferfromdate']);
    this.transferForm.value['transfertodate' ] = new Date(this.transferForm.value['transfertodate']);
    let date1 = new Date(this.transferForm.value['transferfromdate'].getTime() - this.transferForm.value['transferfromdate'].getTimezoneOffset() * 60000).toISOString();
    let date2 = new Date(this.transferForm.value['transfertodate'].getTime() - this.transferForm.value['transfertodate'].getTimezoneOffset() * 60000).toISOString();
    this.transferForm.value['transferfromdate'] = date1;
    this.transferForm.value['transfertodate'] = date2;
    if(this.validateToDate(date1,date2)){
      this.toastrService.error("To date can't be less than From date","Title Error",{ closeButton: true, timeOut: 3000 });
    }
    else{

      if(this.transferForm.value['RId'] != ""){
        //this.transferForm.value['transferfromdate'] = "";
        //this.transferForm.value['transfertodate'] = "";
        this.transferForm.value['servicetype'] = 0;
        this.transferForm.value['status'] = "ShowAll";
        this.transferForm.value['division'] = "ShowAll";
        this.transferForm.value['user'] = "";
        this.transferForm.value['agent'] = "";
      }
      console.log(this.transferForm.value);
      let user="",agent="";

      if (this.transferForm.value['user'] != ''){
        user = this.transferForm.value['user']['UserCode']
      }
      if (this.transferForm.value['agent'] != ''){
        agent = this.transferForm.value['agent']['agentcode']
      }

      let va = {
        "RId": this.transferForm.value['RId'],
        "transferfromdate": this.transferForm.value['transferfromdate'],
        "transfertodate": this.transferForm.value['transfertodate'],
        "servicetype": this.transferForm.value['servicetype'],
        "status": this.transferForm.value['status'],
        "division": this.transferForm.value['division'],
        "user": user,
        "agent": agent
      }

      console.log(va);
      this.loadTransfer(va);
    }
  }

  viewbookings(data: any){
    
  }

  reset(){
    //this.transferForm.reset();
    //this.transferForm.value['transferfromdate'] = new Date();
    //this.transferForm.value['transfertodate'] = new Date();
    //this.transferForm.value['RId'] = "";
    // this.transferForm.patchValue({
    //   transferfromdate: new Date(),
    //   transfertodate: new Date()
    // });

    this.transferForm.patchValue({
      transferfromdate: new Date(),
      transfertodate: new Date(),
      servicetype: 0,
      status: "ShowAll",
      division: "ShowAll",
      user: "",
      agent: "",
      RId: "",
    });

    this.SupplierType = "Supplier";
    this.selectedsupplier = null;
    this.selectedRow_VehicleCategory = "";

    this.loadTransfer(this.transferForm.value);
  }

  onTransferPageChange(event: any) {
    this.transferPageIndex = ((event.first / event.rows) + 1);
    this.transferPageIndex = (this.transferPageIndex * event.rows) - 10;
  }

  onEmailPageChange(event: any){
    this.emailPageIndex = ((event.first / event.rows) + 1);
    this.emailPageIndex = (this.emailPageIndex * event.rows) - 10;
  }

  onDriverPageChange(event: any){
    this.driverPageIndex = ((event.first / event.rows) + 1);
    this.driverPageIndex = (this.driverPageIndex * event.rows) - 10;
  }

  AssignDriverSupplier(){
    this.transferPopupVisible = true;
  }

  cancelPopup(){

  }

  convertStringToDate(dateString: string): Date {
    const parts = dateString.split(' ');
    const dateParts = parts[0].split('-');
    const timeParts = parts[1].split(':');
    // Note: JavaScript Date constructor takes month as 0-indexed (0 for January, 1 for February, etc.)
    return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]), parseInt(timeParts[0]), parseInt(timeParts[1]));
  }

  async getTransferListSingle(va: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.excursionServiceService.getTransferListSingle(va).subscribe(
        (res: any) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async SaveDriverSupplier(){
    this.loading = true;
    let checkedTransferListRows: any = [];
    checkedTransferListRows = this.transferlist.filter((item: { isChecked: boolean; })=> item.isChecked == true);

    let transferSupplierList:any = [];
    
    if((this.SupplierType == "Supplier" && this.selectedsupplier != null) || (this.SupplierType == "Own Asset" && this.selectedDriver != null)
       || (this.SupplierType == "Airport Rep" && this.selectedAirportRep != null)){

      if(checkedTransferListRows.length > 0){
        for(let i=0; i < checkedTransferListRows.length; i++){

          if(checkedTransferListRows[i]['detail'] == null || checkedTransferListRows[i]['detail'] == undefined){

            let data:any = checkedTransferListRows[i];

            data['servicedate'] = new Date(data['servicedate']);
            //console.log(data);
            let date1 = new Date(data['servicedate'].getTime() - data['servicedate'].getTimezoneOffset() * 60000).toISOString();
            let va = {
              'transferdate':date1,
              'transfertype':data['transfertype'],
              'requestid':data['requestid'],
              'tlineno':data['tlineno'],
              'servicetype':data['ServiceType']
            }

            try {
              let transferSingle: any = [];
              const res = await this.getTransferListSingle(va);
              //console.log('async call');
              //console.log(res);
              if(res != null && res != undefined){
                transferSingle = res['data'][0]['transferSingle'];
                console.log(transferSingle);
                checkedTransferListRows[i]['detail'] = transferSingle;

                // const startdateString = checkedTransferListRows[i]['detail'][0]['starttime'];
                // const enddateString = checkedTransferListRows[i]['detail'][0]['endtime'];
                // let date1 = this.convertStringToDate(startdateString);
                // let date2 = this.convertStringToDate(enddateString);
                // checkedTransferListRows[i]['detail'][0]['starttime'] = date1;
                // checkedTransferListRows[i]['detail'][0]['endtime'] = date2;

                checkedTransferListRows[i]['detail'][0]['rownum'] = checkedTransferListRows[i]['RowNum'];
                if(checkedTransferListRows[i]['detail'][0]['assign_status'] != "Confirmed"){
                      checkedTransferListRows[i]['detail'][0]['assign_status'] = "Assigned";
                }
        
                if(this.SupplierType == "Supplier"){  //transfermode 0
                  checkedTransferListRows[i]['detail'][0]['assigntype'] = checkedTransferListRows[i]['detail'][0]['transfertype']; 
                  checkedTransferListRows[i]['detail'][0]['transfertype'] = 0;
        
                  checkedTransferListRows[i]['detail'][0]['partycode'] = this.selectedsupplier.partycode;
                  checkedTransferListRows[i]['detail'][0]['partyname'] = this.selectedsupplier.partyname;

                  //checkedTransferListRows[i]['detail'][0]['RepCode'] = //this.selectedsupplier.partycode;
                  //checkedTransferListRows[i]['detail'][0]['RepName'] = //this.selectedsupplier.partyname;

                  checkedTransferListRows[i]['detail'][0]['vehiclemaxpax'] = 0;
                  checkedTransferListRows[i]['detail'][0]['overridemaxpax'] = 0;
        
                }
                else if(this.SupplierType == "Own Asset"){  //transfermode 1
                  checkedTransferListRows[i]['detail'][0]['assigntype'] = checkedTransferListRows[i]['detail'][0]['transfertype']; 
                  checkedTransferListRows[i]['detail'][0]['transfertype'] = 1;

                  //checkedTransferListRows[i]['detail'][0]['partycode'] = checkedTransferListRows[i]['detail'][0]['preferredsupplier'];
                  //checkedTransferListRows[i]['detail'][0]['partyname'] = checkedTransferListRows[i]['detail'][0]['preferredsuppliername'];

                  checkedTransferListRows[i]['detail'][0]['DriverCode'] = this.selectedDriver.drivercode;
                  checkedTransferListRows[i]['detail'][0]['DriverName'] = this.selectedDriver.drivername;
        
                  checkedTransferListRows[i]['detail'][0]['vehiclemaxpax'] = 0;
                  checkedTransferListRows[i]['detail'][0]['overridemaxpax'] = 0;
                }
                else if(this.SupplierType == "Airport Rep"){
                  checkedTransferListRows[i]['detail'][0]['assigntype'] = checkedTransferListRows[i]['detail'][0]['transfertype']; 
                  checkedTransferListRows[i]['detail'][0]['transfertype'] = 0;

                  checkedTransferListRows[i]['detail'][0]['partycode'] = checkedTransferListRows[i]['detail'][0]['preferredsupplier'];
                  checkedTransferListRows[i]['detail'][0]['partyname'] = checkedTransferListRows[i]['detail'][0]['preferredsuppliername'];

                  checkedTransferListRows[i]['detail'][0]['RepCode'] = this.selectedAirportRep.repcode;
                  checkedTransferListRows[i]['detail'][0]['RepName'] = this.selectedAirportRep.repname;

                  checkedTransferListRows[i]['detail'][0]['vehiclemaxpax'] = 0;
                  checkedTransferListRows[i]['detail'][0]['overridemaxpax'] = 0;
                }
                transferSupplierList.push(checkedTransferListRows[i]['detail'][0]);

              }
              // Process the result here
            } catch (error) {
              console.error('Error:', error);
              // Handle error
            }
          }
          else{

            const startdateString = checkedTransferListRows[i]['detail'][0]['starttime'];
            const enddateString = checkedTransferListRows[i]['detail'][0]['endtime'];
            let date1 = this.convertStringToDate(startdateString);
            let date2 = this.convertStringToDate(enddateString);
            checkedTransferListRows[i]['detail'][0]['starttime'] = date1;
            checkedTransferListRows[i]['detail'][0]['endtime'] = date2;

            checkedTransferListRows[i]['detail'][0]['rownum'] = checkedTransferListRows[i]['RowNum'];

            if(checkedTransferListRows[i]['detail'][0]['assign_status'] != "Confirmed" && this.SupplierType != "Airport Rep"){
                checkedTransferListRows[i]['detail'][0]['assign_status'] = "Assigned";
            }
    
            if(this.SupplierType == "Supplier"){  //transfermode 0
              checkedTransferListRows[i]['detail'][0]['assigntype'] = checkedTransferListRows[i]['detail'][0]['transfertype']; 
              checkedTransferListRows[i]['detail'][0]['transfertype'] = 0;
    
              checkedTransferListRows[i]['detail'][0]['partycode'] = this.selectedsupplier.partycode;
              checkedTransferListRows[i]['detail'][0]['partyname'] = this.selectedsupplier.partyname;

              checkedTransferListRows[i]['detail'][0]['vehiclemaxpax'] = 0;
              checkedTransferListRows[i]['detail'][0]['overridemaxpax'] = 0;
    
            }
            else if(this.SupplierType == "Own Asset"){  //transfermode 1
              checkedTransferListRows[i]['detail'][0]['assigntype'] = checkedTransferListRows[i]['detail'][0]['transfertype']; 
              checkedTransferListRows[i]['detail'][0]['transfertype'] = 1;

              checkedTransferListRows[i]['detail'][0]['DriverCode'] = this.selectedDriver.drivercode;
              checkedTransferListRows[i]['detail'][0]['DriverName'] = this.selectedDriver.drivername;
    
              checkedTransferListRows[i]['detail'][0]['vehiclemaxpax'] = 0;
              checkedTransferListRows[i]['detail'][0]['overridemaxpax'] = 0;
            }
            else if(this.SupplierType == "Airport Rep"){
              checkedTransferListRows[i]['detail'][0]['assigntype'] = checkedTransferListRows[i]['detail'][0]['transfertype']; 
              checkedTransferListRows[i]['detail'][0]['transfertype'] = 0;

              checkedTransferListRows[i]['detail'][0]['RepCode'] = this.selectedAirportRep.repcode;

              checkedTransferListRows[i]['detail'][0]['vehiclemaxpax'] = 0;
              checkedTransferListRows[i]['detail'][0]['overridemaxpax'] = 0;
            }
            transferSupplierList.push(checkedTransferListRows[i]['detail'][0]);

          }
          
        }

        let supplierCode = "";
        let supplierName = "";

        if(this.SupplierType == "Supplier" && this.selectedsupplier != null){
          supplierCode = this.selectedsupplier.partycode;
          supplierName = this.selectedsupplier.partyname;
        }
  
        //console.log(transferSupplierList);
        this.assignmentidList = [];

        if(transferSupplierList.length > 0){
          let va = {"xmlvalue": transferSupplierList,"SupplierCode": supplierCode,"SupplierName": supplierName};
          console.log(va);
    
          this.excursionServiceService.update_supplier_driver_transfer(va).subscribe((res: any) => {
            if(res['result'] == 1){
              this.assignmentidList = res['data'];
              this.toastrService.success("Supplier/Driver Assigned successfully", 'Title Success!', { closeButton: true, timeOut: 3000 });
              this.isEdit = false;
              //this.reset();
              this.loadTransfer(this.transferForm.value);
            }
            else if(res['result'] == 0){
              var msg = res['errors'];
              this.toastrService.error(msg, 'Title Error!', { closeButton: true, timeOut: 3000 });
            }
          });
        }
      }
      else{
        this.toastrService.error("Please select any row to assign the supplier/driver", 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
    }
    else{
      this.toastrService.error("Please select any supplier/driver to assign", 'Title Error!', { closeButton: true, timeOut: 3000 });
    }

    this.loading = false;
    
  }

  getPriorTime(){
    this.excursionServiceService.getPriorTime().subscribe((res: any) => {
      if(res['result'] == 1){
        this.txtPriorTime = res['data'][0]['option_selected'];
      }
      else{
        this.toastrService.error("Prior Time not loaded", 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
    });
  }

  moreActionChange(event: any){
    if(event){
      //console.log(event);
      //console.log(this.MoreAction);
      if(event == 'Update Prior Time'){
        this.showPopupPriorTime = true;
        this.popupLoading = true;
        this.excursionServiceService.getPriorTime().subscribe((res: any) => {
          if(res['result'] == 1){
            this.txtPriorTime = res['data'][0]['option_selected'];
            //this.showPopupPriorTime = true;
          }
          else{
            //this.showPopupPriorTime = true;
            this.toastrService.error("Prior Time not loaded", 'Title Error!', { closeButton: true, timeOut: 3000 });
          }
        });
        this.popupLoading = false;
      }
      else if(event == 'Send Email to Supplier'){
        //this.loading = true;
        let checkedTransferListRows: any = [];
        if(this.assignmentidList != undefined && this.assignmentidList != null){
          if(this.assignmentidList.length > 0){
            checkedTransferListRows = this.assignmentidList;
          }
          else{
            checkedTransferListRows = this.transferlist.filter((item: { isChecked: boolean; })=> item.isChecked == true);  
          }
        }
        else{
          checkedTransferListRows = this.transferlist.filter((item: { isChecked: boolean; })=> item.isChecked == true);
        }

        let assignmentIds: string = "";
        for (let i = 0; i < checkedTransferListRows.length; i++) {
          assignmentIds += checkedTransferListRows[i]['assignmentid'] + ";";
        }

        let va = { 
          "assignmentids" : assignmentIds,
          "partycodes" : ""
        };

        this.excursionServiceService.getSendEmailToSupplier(va).subscribe((res: any) => {
          if(res['result'] == 1){
            this.emaillist = res['data'][0]['EmailSupplierDetails'];
            this.EmailDetails = res['data'][0]['EmailDetails'];
            this.showPopupEmail = true;

            // let distinctPartyCode: string[];
            // distinctPartyCode = this.getDistinctPartyCode(this.emaillist);
            // console.log(distinctPartyCode);
          }
          else{
            this.toastrService.error("No data available to send email to supplier", 'Title Error!', { closeButton: true, timeOut: 3000 });
          }
        });
        //this.loading = false;
      }
      else if(event == 'Driver Duty Sheet'){

        this.transferForm.value['transferfromdate'] = new Date(this.transferForm.value['transferfromdate']);
        this.transferForm.value['transfertodate' ] = new Date(this.transferForm.value['transfertodate']);
        let date1 = new Date(this.transferForm.value['transferfromdate'].getTime() - this.transferForm.value['transferfromdate'].getTimezoneOffset() * 60000).toISOString();
        let date2 = new Date(this.transferForm.value['transfertodate'].getTime() - this.transferForm.value['transfertodate'].getTimezoneOffset() * 60000).toISOString();
        this.transferForm.value['transferfromdate'] = date1;
        this.transferForm.value['transfertodate'] = date2;

        let va = {
          "transferfromdate" : date1,
          "transfertodate" : date2,
          "drivercode" : ""
        }

        this.excursionServiceService.getDriverDutySheet(va).subscribe((res: any) => {
          if(res['result'] == 1){
            this.driverDutySheetlist = [];
            this.driverDutySheetlist = res['data'];
            this.showPopupDriverDutySheet = true;
          }
          else{
            this.toastrService.error("No data available for drivers duty sheet", 'Title Error!', { closeButton: true, timeOut: 3000 });
          }
        });

      }
    }
  }

  getDistinctPartyCode(items: any[]): string[] {
    return [...new Set(items.map(item => item.partycode))];
  }

  productChecked(event: any, rowIndex: number){
    // console.log('product checked ' + rowIndex.toString());
    // console.log(event);
    this.transferlist[rowIndex]['isChecked'] = event.target.checked;
    this.selectedRow_VC = this.transferlist[rowIndex]['shuttle'];

    let filteredRow: any = [];
    filteredRow = this.transferlist.filter((item: { isChecked: boolean; })=> item.isChecked == true);

    if(filteredRow.length == 0){
      this.selectedRow_VC = -1;
    }
  }

  getTransferSingle(data: any, index: number){
    this.loading = true;
    this.tabUnitCostValuebkp = 0;
    this.tabTotalCostPricebkp = 0;

    if(this.transferlist[index]['detail'] == undefined){

      data['servicedate'] = new Date(data['servicedate']);
      //console.log(data);
      let date1 = new Date(data['servicedate'].getTime() - data['servicedate'].getTimezoneOffset() * 60000).toISOString();
      let va = {
        'transferdate':date1,
        'transfertype':data['transfertype'],
        'requestid':data['requestid'],
        'tlineno':data['tlineno'],
        'servicetype':data['ServiceType']
      }

      //console.log(va);

      this.excursionServiceService.getTransferListSingle(va).subscribe((res: any) => {
        this.loading = false;
        if (res['result'] == 1) {
          this.isEdit = false;
          //this.transferDetailList= res['data'];
          this.transferlistSingle = res['data'][0]['transferSingle'];
          this.transferlist[index]['detail'] = this.transferlistSingle;

          this.FlightList = res['data'][0]['FlightList'];
          this.pickupDropoffList = res['data'][0]['PickupDropoffList'];
          this.currencyratelist = res['data'][0]['CurrencyRatesList'];
          console.log(this.FlightList);

          this.tabSaleCurrCode = this.transferlistSingle[0]['salecurrcode'];
          this.tabCostCurrCode = this.transferlistSingle[0]['costcurrcode'];

          let tSaleValue:number = 0;
          tSaleValue = this.transferlist[index]['detail'][0]['unitsalevalue'];

          let convrate: number = 1;
          if(this.tabCostCurrCode != this.tabSaleCurrCode){
            let convratelist:any = this.currencyratelist.filter((item: { currcode: string;tocurr: string })=> item.currcode == this.tabSaleCurrCode && item.tocurr == this.tabCostCurrCode);
            if(convratelist.length > 0){
              convrate = convratelist[0]['convrate'];
            }

            tSaleValue = this.transferlist[index]['detail'][0]['unitsalevalue'] * convrate;
          }

          this.tabUnitSaleValueDiffCurr = tSaleValue;


          if(this.transferlistSingle !== undefined){
            if(this.transferlistSingle.length > 0){

              this.tabTotalProfit =  parseFloat(this.transferlist[index]['detail'][0]['totalsalevalue']) - parseFloat(this.transferlist[index]['detail'][0]['totalcostprice'])

              if (this.tabTotalCostPrice !== 0) {                
                this.tabTotalProfitPerc = (this.tabTotalProfit / parseFloat(this.transferlist[index]['detail'][0]['totalcostprice'])) * 100;
              } else {
                this.tabTotalProfitPerc = 100;
              }

              if(this.transferlist[index]['detail'][0]['assign_status'] == null || this.transferlist[index]['detail'][0]['assign_status'] == ""){
                this.transferlist[index]['detail'][0]['assign_status'] = "Pending";
              }

              if(this.transferlist[index]['detail'][0]['starttime'] != null 
                && this.transferlist[index]['detail'][0]['starttime'] != undefined 
                && this.transferlist[index]['detail'][0]['starttime'] != "")
              {
                  let startDateTime = new Date(this.transferlist[index]['detail'][0]['starttime']);
                  let formattedDate = this.datePipe.transform(startDateTime, 'dd-MM-yyyy HH:mm');
                  if(formattedDate){
                    this.transferlist[index]['detail'][0]['starttime'] = formattedDate.toString();
                  }
              }
          
              if(this.transferlist[index]['detail'][0]['endtime'] != null 
                && this.transferlist[index]['detail'][0]['endtime'] != undefined 
                && this.transferlist[index]['detail'][0]['endtime'] != "")
              {
                  let endDateTime = new Date(this.transferlist[index]['detail'][0]['endtime']);
                  let formattedDate = this.datePipe.transform(endDateTime, 'dd-MM-yyyy HH:mm');
                  if(formattedDate){
                    this.transferlist[index]['detail'][0]['endtime'] = formattedDate.toString();
                  }
              }

            }
          }
        }
        else if(res['result'] == 0){
          var msg = res['errors'];
          this.toastrService.error(msg, 'Title Error!', { closeButton: true, timeOut: 3000 });
        }
      });
    }
    else{
      this.loading = false;
    }
  }

  UpdateNgModelRowData(index: number){

  }

  transferSelectChange(newValue: string, index: number){
    //const selectedId = this.getSelectedId();
    //console.log('Selected ID:', selectedId);
    //this.transferlist[index]['detail'][0]['assign_status'] = newValue;
    //console.log(this.transferlist);
  }

  transferInputChange(myId: string, newValue: string, index:number){
    //console.log(myId+' : '+newValue);
    //this.transferlist[index]['detail'][0][myId] = newValue;
    //console.log(this.transferlist);
  }

  filterSupplier(event:any) { 
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.supplierList.length; i++) { 
        let supplier = this.supplierList[i]; 
        if (supplier.partyname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(supplier); 
        }
    }

    this.filteredSupplier = filtered; 
  }

  supplierChange(event: any){
    //console.log(event);
    //console.log(this.selectedsupplier.partycode);
  }

  filterDriver(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.DriverList.length; i++) { 
        let driver = this.DriverList[i]; 
        if (driver.drivername.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(driver); 
        }
    }

    this.filteredDriver = filtered; 
  }

  driverChange(event: any){

  }

  filterVehicle(event:any) { 
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.VehicleTypeList.length; i++) { 
        let vehicleType = this.VehicleTypeList[i]; 
        if (vehicleType.othcatname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(vehicleType); 
        }
    }

    this.filteredVehicleType = filtered; 
  }

  airportrepChange(event:any){

  }

  filterAirportRep(event:any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.AirportRepList.length; i++) { 
        let airportrep = this.AirportRepList[i]; 
        if (airportrep.repname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(airportrep); 
        }
    }

    this.filteredAirportRep = filtered;
  }

  vehicleTypeChange(event: any){
    console.log(event);
  }

  filterFlight(event:any) { 
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.FlightList.length; i++) { 
        let flight = this.FlightList[i]; 
        if (flight.flightcode.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(flight); 
        }
    }

    this.filteredFlightNo = filtered; 
  }

  userChange(event: any){

  }

  filterUser(event: any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.UserList.length; i++) { 
        let user = this.UserList[i]; 
        if (user.UserName.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(user); 
        }
    }

    this.filteredUser = filtered; 
  }

  agentChange(event: any){

  }

  filterAgent(event: any){
    let filtered: any[] = []; 
    let query = event.query; 
    for (let i = 0; i < this.AgentList.length; i++) { 
        let agent = this.AgentList[i]; 
        if (agent.agentname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
            filtered.push(agent); 
        }
    }

    this.filteredAgent = filtered; 
  }

  flightNoChange(event: any){
    //console.log(event);
    this.tabFlightTime = event.flighttime;
  }

  OverrideCostCheckChange(event: any){
    this.overridecheck = !event.target.checked;
  }

  UnitCostValueChange(event: any, rowIndex: number){
    //console.log(event.target.value);
    let unitcost:number = 0;
    if(event.target.value != ""){
      unitcost = parseFloat(event.target.value);
    }

    let tSaleValue:number = 0;
    tSaleValue = this.tabUnitSaleValue;

    let convrate: number = 1;
    if(this.tabCostCurrCode != this.tabSaleCurrCode){
      let convratelist:any = this.currencyratelist.filter((item: { currcode: string;tocurr: string })=> item.currcode == this.tabSaleCurrCode && item.tocurr == this.tabCostCurrCode);
      if(convratelist.length > 0){
        convrate = convratelist[0]['convrate'];
      }

      tSaleValue = this.tabUnitSaleValue * convrate;
    }

    //this.tabUnitSaleValueDiffCurr = tSaleValue;

    let tabUCost:number = 0;
    tabUCost = this.tabUnitCostValue;
   
    if(tSaleValue < unitcost){
      this.toastrService.error("Cost value can't be higher than Sale value", 'Title Error!', { closeButton: true, timeOut: 3000 });
      //event.target.value = 0;
      unitcost = 0;
      this.tabUnitCostValue = 0;
    }

    let pax: number = 1;
    if(this.transferlist[rowIndex]['adults'] != "" && this.transferlist[rowIndex]['adults'] != undefined
        && this.transferlist[rowIndex]['ServiceType'] == "AIRPORT"){
      pax = this.transferlist[rowIndex]['adults'];
    }

    if(this.transferlist[rowIndex]['ServiceType'] == "TRANSFER"){
      pax = this.transferlist[rowIndex]['units'];
    }

    let totCostPrice:number = 0;
    totCostPrice = this.tabTotalCostPrice;

    //this.tabTotalCostPrice = ((unitcost * pax) * convrate) + this.tabParkingFee;
    this.tabTotalCostPrice = (unitcost * pax) + this.tabParkingFee;

    // if(tSaleValue < this.tabTotalCostPrice){
    //   this.toastrService.error("Total Cost value can't be higher than Total Sale value", 'Title Error!', { closeButton: true, timeOut: 3000 });
    //   //event.target.value = 0;
    //   //unitcost = 0;
    //   this.tabUnitCostValue = tabUCost;
    //   this.tabTotalCostPrice = totCostPrice;
    // }

    this.tabTotalProfit = this.tabTotalSaleValue - this.tabTotalCostPrice;

    if (this.tabTotalCostPrice !== 0) {                
      this.tabTotalProfitPerc = (this.tabTotalProfit / this.tabTotalCostPrice) * 100;
    } else {
      this.tabTotalProfitPerc = 100;
    }
  }

  ParkingFeeValueChange(event: any, rowIndex: number){
    let parkFee:number = 0;
    if(event.target.value != ""){
      parkFee = parseFloat(event.target.value);
    }

    let convrate: number = 1;
    if(this.tabCostCurrCode != this.tabSaleCurrCode){
      let convratelist:any = this.currencyratelist.filter((item: { currcode: string;tocurr: string })=> item.currcode == this.tabSaleCurrCode && item.tocurr == this.tabCostCurrCode);
      if(convratelist.length > 0){
        convrate = convratelist[0]['convrate'];
      }
    }

    //this.tabTotalCostPrice = this.tabUnitCostValue + (parkFee * convrate);
    this.tabTotalCostPrice = this.tabUnitCostValue + parkFee;
    this.tabTotalProfit = this.tabTotalSaleValue - this.tabTotalCostPrice;

    if (this.tabTotalCostPrice !== 0) {                
      this.tabTotalProfitPerc = (this.tabTotalProfit / this.tabTotalCostPrice) * 100;
    } else {
      this.tabTotalProfitPerc = 100;
    }
  }

  CompSuppCheckChange(event: any){
    if(event.target.checked){
      //this.tabTotalSaleValue = 0;
      this.tabUnitCostValuebkp = this.tabUnitCostValue;
      this.tabTotalCostPricebkp = this.tabTotalCostPrice;
      this.tabTotalCostPrice = 0;
      this.tabUnitCostValue = 0;
    }
    else{
      this.tabUnitCostValue = this.tabUnitCostValuebkp;
      this.tabTotalCostPrice = this.tabTotalCostPricebkp;
      //this.tabTotalSaleValue = this.tabUnitSaleValue + this.tabParkingFee;
    }

    this.tabTotalProfit = this.tabTotalSaleValue - this.tabTotalCostPrice;

    if (this.tabTotalCostPrice !== 0) {                
      this.tabTotalProfitPerc = (this.tabTotalProfit / this.tabTotalCostPrice) * 100;
    } else {
      this.tabTotalProfitPerc = 100;
    }

  }

  filterPickupLocation(event:any, transferType: string) { 
    // console.log(transferType);
    // console.log(this.pickupDropoffList);
    if(transferType == "DEPARTURE" || transferType == "INTERHOTEL"){
      let filtered: any[] = []; 
      let query = event.query; 
      for (let i = 0; i < this.pickupDropoffList.length; i++) { 
          let pickupDropoff = this.pickupDropoffList[i]; 
          if (pickupDropoff.partyname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
              filtered.push(pickupDropoff);
          }
      }
      this.filteredPickupLocation = filtered; 
    }
  }

  pickupLocationChange(event: any){

  }

  filterDropoffLocation(event: any, transferType: string){
    // console.log(transferType);
    // console.log(this.pickupDropoffList);
    if(transferType == "ARRIVAL" || transferType == "INTERHOTEL"){
      let filtered: any[] = []; 
      let query = event.query; 
      for (let i = 0; i < this.pickupDropoffList.length; i++) { 
          let pickupDropoff = this.pickupDropoffList[i]; 
          if (pickupDropoff.partyname.toLowerCase().indexOf(query.toLowerCase()) == 0 || query.trim() == '') { 
              filtered.push(pickupDropoff);
          }
      }
      this.filteredDropoffLocation = filtered; 
    }
  }

  dropOffLocationChange(event: any){

  }

  transferSingleEdit(rowIndex: number){
    this.isEdit = true;
    let vCategory = "";
    // if(this.transferlist[rowIndex]['detail'][0]['shuttle'] == 0){
    //   vCategory = "Private";
    // }
    // else{
    //   vCategory = "SIC";
    // }
    this.tabVehicleCategory = this.transferlist[rowIndex]['detail'][0]['shuttle'];
    this.tabVehicleType = {
      "othcatcode" : this.transferlist[rowIndex]['detail'][0]['cartypecode'],
      "othcatname" : this.transferlist[rowIndex]['detail'][0]['othcatname']
    }
    //this.tabVehicleType = this.transferlist[rowIndex]['detail'][0]['othcatname'];
    this.tabStatus = this.transferlist[rowIndex]['detail'][0]['assign_status'];

    if(this.transferlist[rowIndex]['detail'][0]['assign_status'] == null){
      this.tabStatus = 'Pending';
    }
    
    this.tabConfNo = this.transferlist[rowIndex]['detail'][0]['confno'];
    this.tabVehicleNo = this.transferlist[rowIndex]['detail'][0]['vehicleno'];
    let flightDetails: any = [];
    flightDetails = this.FlightList.filter((item: { flightcode: string; })=> item.flightcode == this.transferlist[rowIndex]['detail'][0]['flightcode']);

    if(flightDetails != null){
      if(flightDetails.length > 0){
        this.tabFlightNo = {
          "flight_tranid":  flightDetails[0].flight_tranid,
          "flightcode": flightDetails[0].flightcode,
          "airportbordername": flightDetails[0].airportbordername,
          "airportbordercode": flightDetails[0].airportbordercode,
          "flighttime": flightDetails[0].flighttime
        }
      }
      else{
        this.tabFlightNo = {
          "flight_tranid":  "",
          "flightcode": "",
          "airportbordername": "",
          "airportbordercode": "",
          "flighttime": ""
        }
      }
    }

    //this.tabFlightNo = this.transferlist[rowIndex]['detail'][0]['flightcode'];
    this.tabFlightTime = this.transferlist[rowIndex]['detail'][0]['flighttime'];

    this.tabPickupLocation = {
      "partycode":this.transferlist[rowIndex]['detail'][0]['pickup'],
      "partyname":this.transferlist[rowIndex]['detail'][0]['pickupName']
    }
    //this.tabPickupLocation = this.transferlist[rowIndex]['detail'][0]['pickupName'];

    this.tabDropoffLocation = {
      "partycode":this.transferlist[rowIndex]['detail'][0]['dropoff'],
      "partyname":this.transferlist[rowIndex]['detail'][0]['dropoffName']
    }
    //this.tabDropoffLocation = this.transferlist[rowIndex]['detail'][0]['dropoffName'];

    this.tabUnitSaleValue = this.transferlist[rowIndex]['detail'][0]['unitsalevalue'];

    this.tabTotalSaleValue = this.transferlist[rowIndex]['detail'][0]['totalsalevalue'];
    this.tabUnitCostValue = this.transferlist[rowIndex]['detail'][0]['unitcostvalue'];
    this.tabParkingFee = parseFloat(this.transferlist[rowIndex]['detail'][0]['parkingfee']);
    this.tabOverrideCostCheck = this.transferlist[rowIndex]['detail'][0]['overridecost'];
    this.tabTotalCostPrice = this.transferlist[rowIndex]['detail'][0]['totalcostprice'];


    this.tabTotalProfit = this.tabTotalSaleValue - this.tabTotalCostPrice;

    if (this.tabTotalCostPrice !== 0) {                
      this.tabTotalProfitPerc = (this.tabTotalProfit / this.tabTotalCostPrice) * 100;
    } else {
      this.tabTotalProfitPerc = 100;
    }

    this.tabPickupTime = this.transferlist[rowIndex]['detail'][0]['pickuptime'];

    // if(this.transferlist[rowIndex]['detail'][0]['starttime'] != null 
    //   && this.transferlist[rowIndex]['detail'][0]['starttime'] != undefined 
    //   && this.transferlist[rowIndex]['detail'][0]['starttime'] != "")
    // {
    //     let startDateTime = new Date(this.transferlist[rowIndex]['detail'][0]['starttime']);
    //     let formattedDate = this.datePipe.transform(startDateTime, 'dd-MM-yyyy HH:mm');
    //     if(formattedDate){
    //       this.tabStartDateTime = formattedDate.toString();
    //     }
    //     //console.log(startDateTime);
    // }

    // if(this.transferlist[rowIndex]['detail'][0]['endtime'] != null 
    //   && this.transferlist[rowIndex]['detail'][0]['endtime'] != undefined 
    //   && this.transferlist[rowIndex]['detail'][0]['endtime'] != "")
    // {
    //     let endDateTime = new Date(this.transferlist[rowIndex]['detail'][0]['endtime']);
    //     let formattedDate = this.datePipe.transform(endDateTime, 'dd-MM-yyyy HH:mm');
    //     if(formattedDate){
    //       this.tabEndDateTime = formattedDate.toString();
    //     }
    // }
    
    this.tabStartDateTime = this.transferlist[rowIndex]['detail'][0]['starttime'];
    this.tabEndDateTime = this.transferlist[rowIndex]['detail'][0]['endtime'];
    this.tabCompSupCheck = this.transferlist[rowIndex]['detail'][0]['complimentaryfromsupplier'];

    this.tabRemarks = this.transferlist[rowIndex]['detail'][0]['remarks'];
    this.tabSupplierRemarks = this.transferlist[rowIndex]['detail'][0]['supplier_remarks'];
    this.tabCustomerRemarks = this.transferlist[rowIndex]['detail'][0]['customer_remarks'];
    this.tabArrivalRemarks = this.transferlist[rowIndex]['detail'][0]['arrival_remarks'];
    this.tabDepartureRemarks = this.transferlist[rowIndex]['detail'][0]['departure_remarks'];
  }

  transferSingleCancel(rowIndex: number){
    this.isEdit = false;
  }

  transferDetailSave(rowIndex: number){
    ////this.isEdit = false;
    // if(this.tabStatus == 'Confirmed'){
    //   if(this.tabConfNo == ''){
    //     this.toastrService.warning("Please enter conf No", 'Title Warning!', { closeButton: true, timeOut: 3000 });
    //     return;
    //   }
    // }

    this.loading = true;
    this.transferlist[rowIndex]['detail'][0]['shuttle'] = this.tabVehicleCategory;
    this.transferlist[rowIndex]['detail'][0]['cartypecode'] = this.tabVehicleType.othcatcode;
    this.transferlist[rowIndex]['detail'][0]['othcatname'] = this.tabVehicleType.othcatname;
    this.transferlist[rowIndex]['detail'][0]['assign_status'] = this.tabStatus;
    this.transferlist[rowIndex]['detail'][0]['confno'] = this.tabConfNo;
    this.transferlist[rowIndex]['detail'][0]['vehicleno'] = this.tabVehicleNo;

    this.transferlist[rowIndex]['detail'][0]['flightcode'] = this.tabFlightNo.flightcode;
    this.transferlist[rowIndex]['detail'][0]['flighttime'] = this.tabFlightNo.flighttime;
    this.transferlist[rowIndex]['detail'][0]['flight_tranid'] = this.tabFlightNo.flight_tranid;

    this.transferlist[rowIndex]['detail'][0]['pickupName'] = this.tabPickupLocation.partyname;
    this.transferlist[rowIndex]['detail'][0]['pickup'] = this.tabPickupLocation.partycode;

    this.transferlist[rowIndex]['detail'][0]['dropoffName'] = this.tabDropoffLocation.partyname;
    this.transferlist[rowIndex]['detail'][0]['dropoff'] = this.tabDropoffLocation.partycode;

    this.transferlist[rowIndex]['detail'][0]['unitsalevalue'] = this.tabUnitSaleValue;
    this.transferlist[rowIndex]['detail'][0]['totalsalevalue'] = this.tabTotalSaleValue;

    this.transferlist[rowIndex]['detail'][0]['unitcostvalue'] = this.tabUnitCostValue;
    this.transferlist[rowIndex]['detail'][0]['parkingfee'] = this.tabParkingFee;
    this.transferlist[rowIndex]['detail'][0]['overridecost'] = this.tabOverrideCostCheck;
    this.transferlist[rowIndex]['detail'][0]['totalcostprice'] = this.tabTotalCostPrice;

    this.transferlist[rowIndex]['detail'][0]['pickuptime'] = this.tabPickupTime;
    this.transferlist[rowIndex]['detail'][0]['starttime'] = this.tabStartDateTime;
    this.transferlist[rowIndex]['detail'][0]['endtime'] = this.tabEndDateTime;
    this.transferlist[rowIndex]['detail'][0]['complimentaryfromsupplier'] = this.tabCompSupCheck;

    this.transferlist[rowIndex]['detail'][0]['remarks'] =  this.tabRemarks;
    this.transferlist[rowIndex]['detail'][0]['supplier_remarks'] = this.tabSupplierRemarks;
    this.transferlist[rowIndex]['detail'][0]['customer_remarks'] = this.tabCustomerRemarks;
    this.transferlist[rowIndex]['detail'][0]['arrival_remarks'] = this.tabArrivalRemarks;
    this.transferlist[rowIndex]['detail'][0]['departure_remarks'] = this.tabDepartureRemarks;

    this.transferlist[rowIndex]['detail'][0]['partycode'] = this.transferlist[rowIndex]['detail'][0]['preferredsupplier'];
    this.transferlist[rowIndex]['detail'][0]['partyname'] = this.transferlist[rowIndex]['detail'][0]['preferredsuppliername'];
    //this.transferlist[rowIndex]['detail'][0]['DriverCode'] = this.transferlist[rowIndex]['detail'][0]['DriverCode'];
    //this.transferlist[rowIndex]['detail'][0]['DriverName'] = this.transferlist[rowIndex]['detail'][0]['DriverName'];

    let transferSupplierList:any = [];
    transferSupplierList = this.transferlist[rowIndex]['detail'];

    const startdateString = transferSupplierList[0]['starttime'];
    const enddateString = transferSupplierList[0]['endtime'];
    let date1 = this.convertStringToDate(startdateString);
    let date2 = this.convertStringToDate(enddateString);
    transferSupplierList[0]['starttime'] = date1;
    transferSupplierList[0]['endtime'] = date2;

    transferSupplierList[0]['rownum'] = this.transferlist[rowIndex]['RowNum'];
    transferSupplierList[0]['assigntype'] = transferSupplierList[0]['transfertype']; 
    transferSupplierList[0]['vehiclemaxpax'] = 0;
    transferSupplierList[0]['overridemaxpax'] = 0;

    let supplierCode = "";
    let supplierName = "";

    if(this.SupplierType == "Supplier") {
      //supplierCode = this.selectedsupplier.partycode;
      //supplierName = this.selectedsupplier.partyname;
      transferSupplierList[0]['transfertype'] = 0;
    }
    else{
      transferSupplierList[0]['transfertype'] = 1;
    }

    //console.log(transferSupplierList);
    let va = {"xmlvalue": transferSupplierList,"SupplierCode": supplierCode,"SupplierName": supplierName};
    console.log(va);

    this.excursionServiceService.update_supplier_driver_transfer(va).subscribe((res: any) => {
      if(res['result'] == 1){
        this.toastrService.success("Details saved successfully", 'Title Success!', { closeButton: true, timeOut: 3000 });
        this.isEdit = false;
        //this.reset();
        this.loadTransfer(this.transferForm.value);
      }
      else if(res['result'] == 0){
        var msg = res['errors'];
        this.toastrService.error(msg, 'Title Error!', { closeButton: true, timeOut: 3000 });
      }
    });

    this.loading = false;

  }

  startDateTimeChange(event: any){
    const parts = event.split(' ');
    //console.log(parts);
    const dateParts = parts[0].split('-');
    const timeParts = parts[1].split(':');
    //console.log(dateParts);
    //console.log(timeParts);
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10);
    const year = parseInt(dateParts[2], 10);
    const hour = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);

    // Validate day and month
    if (day > 31) {
      // If day or month exceeds the limit, reset the value
      this.tabStartDateTime = '';
    }
    else if (month > 12) {
      this.tabStartDateTime = '';
    }
    else if (hour > 23) {
      this.tabStartDateTime = '';
    }
    else if (minutes > 59) {
      this.tabStartDateTime = '';
    }
    else {
      this.tabStartDateTime = event;
      this.tabStartDateTime = day + "-"+month+"-"+year+" "+ (hour - this.txtPriorTime)+":"+minutes;
    }
  }

  endDateTimeChange(event: any){
    const parts = event.split(' ');
    //console.log(parts);
    const dateParts = parts[0].split('-');
    const timeParts = parts[1].split(':');
    //console.log(dateParts);
    //console.log(timeParts);
    const day = parseInt(dateParts[0], 10);
    const month = parseInt(dateParts[1], 10);
    const year = parseInt(dateParts[2], 10);
    const hour = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);

    // Validate day and month
    if (day > 31) {
      // If day or month exceeds the limit, reset the value
      this.tabEndDateTime = '';
    }
    else if (month > 12) {
      this.tabEndDateTime = '';
    }
    else if (hour > 23) {
      this.tabEndDateTime = '';
    }
    else if (minutes > 59) {
      this.tabEndDateTime = '';
    }
    else {
      this.tabEndDateTime = event;
    }
  }

  pickupTimeChange(event: any){
    const timeParts = event.split(':');
    const hour = parseInt(timeParts[0], 10);
    const minutes = parseInt(timeParts[1], 10);

    if (hour > 23) {
      this.tabPickupTime = '';
    }
    else if (minutes > 59) {
      this.tabPickupTime = '';
    }
    else {
      this.tabPickupTime = event;
    }

  }

  updatePriorTime(priorTime: number){
    this.loading = true;
    let va = {"PriorTime": priorTime};
    this.excursionServiceService.updatePriorTime(va).subscribe((res: any) => {
      this.loading = false;
      if(res['result'] == 1){
        this.toastrService.success("Prior Time Updated Successfully", 'Title Success!', { closeButton: true, timeOut: 3000 });
        this.showPopupPriorTime = false;
        this.MoreAction = "";
      }
      else{
        this.toastrService.error("Failed to update Prior Time", 'Title Error!', { closeButton: true, timeOut: 3000 });
        this.showPopupPriorTime = true;
      }
    });
  }

  async sendEmailToSupplier_async(va: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.excursionServiceService.SendEmailToSupplier(va).subscribe(
        (res: any) => {
          resolve(res);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  async sendEmailToSupplier(){
    
    this.loading = true;
    // let bodyData = "";
    // bodyData += "<html>";
    // bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Dear Team,</strong><strong> ######</strong></span></p>";
    // bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'>Warm greeting from Royal Park!!</span></p>";
    let distinctPartyCode: string[];
    distinctPartyCode = this.getDistinctPartyCode(this.emaillist);
    console.log(distinctPartyCode);
    for(let r=0; r < distinctPartyCode.length; r++){

      let strStatus = "EMPTY";
      let strToEmail = "";
      let lstToEmail: any[] = [];
      let strSuppliername = "";
      let strEmailTittle = "";
      let strEmailCC = "";
      let bodyData = "";
      let emailsuppListAll: any = [];
      let strAssigmnetIds = "";
      if(this.emaillist.length > 0){
        let suppConfLink = "";

        let partycodelist = this.emaillist.filter((item: { partycode: string; })=> item.partycode == distinctPartyCode[r]);
        console.log(partycodelist);
        bodyData += "<html>";
        bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Dear Team,</strong><strong> ######</strong></span></p>";
        bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'>Warm greeting from Royal Park!!</span></p>";

        for(let i=0; i < partycodelist.length; i++){
          let emailsuppList: any = [];
          let id = partycodelist[i]['assignmentid'];
          suppConfLink = partycodelist[i]['supplierConfLink'];
          if (strAssigmnetIds == "")
          {
              strAssigmnetIds = id;
          }
          else
          {
              strAssigmnetIds = strAssigmnetIds + "," + id;
          }
  
          for(let j=0; j < partycodelist.length; j++){
            if(partycodelist[j]['partycode'] != ""){
              emailsuppList.push(partycodelist[j]['partycode']);
              emailsuppListAll.push(partycodelist[j]['partycode']);
            }
          }
  
          let noDupEmailSupplierList: any = Array.from(new Set(emailsuppList));
          let noDupEmailSupplierListAll: any = Array.from(new Set(emailsuppListAll));
  
          if(noDupEmailSupplierList.length == 1 && noDupEmailSupplierListAll.length == 1){
            let transferdate = new Date(partycodelist[i]['transferdate']);
            let formattedDate = this.datePipe.transform(transferdate, 'dd-MM-yyyy');
  
            if(strEmailTittle == ""){
              strEmailTittle = "Transfer Booking Request for " + formattedDate;
            }
            else{
              strEmailTittle += " and " + formattedDate;
            }
  
            for(let k=0; k < noDupEmailSupplierList.length; k++){
  
              let lstMailSentIds:any = [];
  
              let lstArrival:any = partycodelist.filter((item: { assigntype: string; partycode:string })=> item.assigntype == "ARRIVAL" && item.partycode == noDupEmailSupplierList[k]);
              let lstDeparture:any = partycodelist.filter((item: { assigntype: string; partycode:string })=> (item.assigntype == "INTERHOTEL" || item.assigntype == "DEPARTURE") && item.partycode == noDupEmailSupplierList[k]);
  
              if(lstArrival.length > 0 || lstDeparture.length > 0){
                if(lstArrival.length > 0){
  
                  bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'>Please find below details of the <span  style='color:#C0392B'><strong>Arrival Transfer</strong></span> Booking Request for </span><span style='color:#C0392B'><strong>" + formattedDate + "</strong>.</span></p>";
                  bodyData += "<table style='font-family:calibri,sans-serif;border-collapse;border:1px solid #D6D6D6;'>";
                  bodyData += "<tbody>";
                  bodyData += "<tr style='height: 36px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'>";
                  bodyData += "<td style='width: 95px; height: 36px; text-align: center;font-family:calibri,sans-serif;border-collapse;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Booking Ref</strong></span></td>";

                  if(this.appClient == "RoyalPark"){
                    bodyData += "<td style='width: 95px; height: 36px; text-align: center;font-family:calibri,sans-serif;border-collapse;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Voucher No</strong></span></td>";
                  }

                  bodyData += "<td style='width: 200px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Guest Name</strong></span></td>";
                  bodyData += "<td style='width: 53px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Pax</strong></span></td>";
                  bodyData += "<td style='width: 66px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Flight</strong></span></td>";
                  bodyData += "<td style='width: 108px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Arrival Time</strong></span></td>";
                  bodyData += "<td style='width: 169px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Arrival Airport</strong></span></td>";
                  bodyData += "<td style='width: 136px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Drop Off&nbsp;</strong></span></td>";
                  bodyData += "<td style='width: 99px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>&nbsp;Vehicle Type</strong></span></td>";
                  bodyData += "<td style='width: 99px; height: 36px; text-align: center;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>&nbsp;Remarks</strong></span></td>";
                  bodyData += "</tr>";
  
                  lstArrival.forEach((item: any) => {

                    let tdate = new Date(item.transferdate);
                    let fDate = this.datePipe.transform(tdate, 'dd-MM-yyyy');

                    if(fDate == formattedDate){
                      bodyData += "<tr style='height: 17px;border:1px solid #D6D6D6;'>";
                      bodyData += "<td style='width: 95px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.requestid + "</span></td>";

                      if(this.appClient == "RoyalPark"){
                        bodyData += "<td style='width: 95px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.VoucherNo + "</span></td>";
                      }

                      bodyData += "<td style='width: 200px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.Guestname + "</span></td>";
                      bodyData += "<td style='width: 53px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.pax + "</span></td>";
                      bodyData += "<td style='width: 66px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.flightcode + "</span></td>";
                      bodyData += "<td style='width: 108px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.flighttime + "</span></td>";
                      bodyData += "<td style='width: 169px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.pickupName + "</span></td>";
                      bodyData += "<td style='width: 136px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.dropoffName + "</span></td>";
                      bodyData += "<td style='width: 99px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.othcatname + "</span></td>";
                      bodyData += "<td style='width: 99px; height: 17px;border:1px solid #D6D6D6;'><span style='color: #4F4949;font-family:calibri,sans-serif;'>" + item.Remarks + "</span></td>";
                      bodyData += "</tr>";
    
                      if (strToEmail == "")
                      {
                          strToEmail = item.email;
                      }

                      let toAdd = item.email.split(",");

                      if(toAdd.length > 0){
                        for(let i=0; i < toAdd.length; i++){
                          lstToEmail.push(toAdd[i]);
                        }
                      }
    
                      if (strSuppliername == "")
                      {
                          strSuppliername = item.partyname;
                      }
    
                      lstMailSentIds.push(item.assignmentid);
                    }
                  });
  
                  bodyData += "</tbody>";
                  bodyData += "</table>";
                  bodyData += "<p><span style='color: #4F4949;'>&nbsp;</span></p>";
  
                }
  
                if(lstDeparture.length > 0){
  
                  bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;border-collapse;'>Please find below details of the <span style='color:#C0392B'><strong>Departure/Inter Hotel Transfer</strong></span> Booking Request  for  </span><span style='color:#C0392B'><strong>" + formattedDate + "</strong>.</span></p>";
                  bodyData += "<table style='font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'>";
                  bodyData += "<tbody>";
                  bodyData += "<tr>";
                  bodyData += "<td style='width: 101px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Booking Ref</strong></span></td>";

                  if(this.appClient == "RoyalPark"){
                    bodyData += "<td style='width: 101px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Voucher No</strong></span></td>";
                  }

                  bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Transfer Type</strong></span></td>";
                  bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Pickup Time</strong></span></td>";
                  bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Guest Name</strong></span></td>";
                  bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Pax</strong></span></td>";
                  bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Flight</strong></span></td>";
                  bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>Flight Time</strong></span></td>";
                  bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>&nbsp;&nbsp;Pickup From</strong></span></td>";
                  bodyData += "<td style='width: 103px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>&nbsp;Departure Airport</strong></span></td>";
                  bodyData += "<td style='width: 104px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>&nbsp;&nbsp;Vehicle Type</strong></span></td>";
                  bodyData += "<td style='width: 104px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'><strong>&nbsp;&nbsp;Remarks</strong></span></td>";
                  bodyData += "</tr>";
  
                  lstDeparture.forEach((item: any) => {

                    let tdate = new Date(item.transferdate);
                    let fDate = this.datePipe.transform(tdate, 'dd-MM-yyyy');

                    if(fDate == formattedDate){
                      bodyData += "<tr>";
                      bodyData += "<td style='width: 101px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.requestid + "</span></td>";

                      if(this.appClient == "RoyalPark"){
                        bodyData += "<td style='width: 101px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.VoucherNo + "</span></td>";
                      }

                      bodyData += "<td style='width: 101px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.assigntype + "</span></td>";
                      bodyData += "<td style='width: 101px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.pickuptime + "</span></td>";
                      bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.Guestname + "</span></td>";
                      bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.pax + "</span></td>";
                      bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.flightcode + "</span></td>";
                      bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.flighttime + "</span></td>";
                      bodyData += "<td style='width: 102px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.pickupName + "</span></td>";
                      bodyData += "<td style='width: 103px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.dropoffName + "</span></td>";
                      bodyData += "<td style='width: 104px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.othcatname + "</span></td>";
                      bodyData += "<td style='width: 104px;font-family:calibri,sans-serif;border-collapse;color:#D6D6D6;border:1px solid #D6D6D6;'><span style='color: #4F4949;'>" + item.Remarks + "</span></td>";
                      bodyData += "</tr>";
    
                      if (strToEmail == "")
                      {
                          strToEmail = item.email;
                      }

                      let toAdd = item.email.split(",");

                      if(toAdd.length > 0){
                        for(let i=0; i < toAdd.length; i++){
                          lstToEmail.push(toAdd[i]);
                        }
                      }
    
                      if (strSuppliername == "")
                      {
                          strSuppliername = item.partyname;
                      }
    
                      lstMailSentIds.push(item.assignmentid);
                    }
                  });
  
                  bodyData += "</tbody>";
                  bodyData += "</table>";
                }
              }
            }
            strStatus = "SEND";
          }
          else{
            strStatus = "MORE";
          }
        }

        if(this.appClient != "RoyalAdventure"){
          let conflinkdata = "";
          conflinkdata = "Transfer;" + strAssigmnetIds;
    
          let encryptedText = this.Encryption(conflinkdata);
          let encodedData = encodeURIComponent(encryptedText);
    
          bodyData += '<div id="btn-toprocess"><a href="'+ suppConfLink +'?q=' + encodedData + '" target="_blank"><button type="button" style="background-color:#1c84c6;border:none;color:white;padding: 15px 32px;text-align:center;text-decoration:none;display:inline-block;font-size: 16px;">Accept Service</button></a></div>';
        }
        
  
        bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'>&nbsp;</span></p>";
        bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'>With Regards,</span></p>";
        bodyData += "<p><span style='color: #4F4949;font-family:calibri,sans-serif;'><strong>Royal Park</strong></span></p>";
        bodyData += "</html>";
      }
      else{
        strStatus = "EMPTY";
      }

      let uniqueEmailList: string[] = [];
      uniqueEmailList = this.removeDuplicates(lstToEmail);
  
      let va ={
        "status":strStatus,
        "AssigmnetIds": strAssigmnetIds,
        "FromEmail": this.EmailDetails[0]['FromEmail'],
        "MailPwd": this.EmailDetails[0]['MailPwd'],
        "MailServer": this.EmailDetails[0]['MailServer'],
        "MailPort": this.EmailDetails[0]['MailPort'],
        "ToEmail": uniqueEmailList, //strToEmail,
        "MailBody": bodyData.replace("######", strSuppliername),
        "Subject": strEmailTittle,
        "CCEmail": strEmailCC,
      }
  
      if(strStatus == "MORE"){
        this.toastrService.error("Selected more than one supplier service. Please select a supplier service.",'Title Error!', { closeButton: true, timeOut: 3000 })
      }
      else if(strStatus == "EMPTY"){
        this.toastrService.error("Please select any booking for send email",'Title Error!', { closeButton: true, timeOut: 3000 })
      }
      else{
        console.log(va);
  
        const res = await this.sendEmailToSupplier_async(va);
  
        if(res != null && res != undefined){
          //this.toastrService.success("Email Send Successfully", 'Title Success!', { closeButton: true, timeOut: 3000 });
          //this.loadTransfer(this.transferForm.value);
          //this.showPopupEmail = false;
          //this.MoreAction = "";
        }
        else{
          //this.toastrService.error("Failed to Sending Email", 'Title Error!', { closeButton: true, timeOut: 3000 });
          //this.showPopupEmail = false;
          //this.MoreAction = "";
        }
  
        // this.excursionServiceService.SendEmailToSupplier(va).subscribe((res: any) => {
        //   //this.loading = false;
        //   if(res['result'] == 1){
        //     this.toastrService.success("Email Send Successfully", 'Title Success!', { closeButton: true, timeOut: 3000 });
        //     this.loadTransfer(this.transferForm.value);
        //     this.showPopupEmail = false;
        //     this.MoreAction = "";
        //   }
        //   else{
        //     this.toastrService.error("Failed to Sending Email", 'Title Error!', { closeButton: true, timeOut: 3000 });
        //     this.showPopupEmail = false;
        //     this.MoreAction = "";
        //   }
        // });
      }
    }

    this.toastrService.success("Email Send Successfully", 'Title Success!', { closeButton: true, timeOut: 3000 });
    this.loadTransfer(this.transferForm.value);
    this.showPopupEmail = false;
    this.MoreAction = "";
    this.loading = false;
  }

  removeDuplicates<T>(arr: T[]): T[] {
    return Array.from(new Set(arr));
  }

  downloadDriverDutySheet(){
    // import("xlsx").then(xlsx => {
    //   const worksheet = xlsx.utils.json_to_sheet(this.driverDutySheetlist);
    //   const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    //   const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
    //   this.saveAsExcelFile(excelBuffer, "DriverDutySheet");
    // });

    const currentDate = new Date();
    const formattedDate = this.datePipe.transform(currentDate, 'ddMMyyyyHHmmss');
    let fileName = 'DriverDutySheet_'+ formattedDate + '.xlsx';

    for(let i=0; i < this.driverDutySheetlist.length; i++){
      this.driverDutySheetlist[i].transferdate = this.datePipe.transform(this.driverDutySheetlist[i].transferdate,'dd-MM-yyyy');
    }

    let va = {
      "data": this.driverDutySheetlist
    }

    this.excursionServiceService.export_DriverDutySheetReport(va).subscribe((blob: Blob) => {
      // Create a blob URL for the Blob object
      const url = window.URL.createObjectURL(blob);

      // Create a link element and set its attributes
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      // Trigger the download by simulating a click on the link
      link.click();

      // Clean up by revoking the blob URL
      window.URL.revokeObjectURL(url);
    },
    error => {
      // Handle error
      console.error('Error downloading file:', error);
    });

  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  Encryption(text: string): string{
    let encryptedText: string = "";
    const key = 'supConfNum@@2024';
    encryptedText = CryptoJS.AES.encrypt(text, key).toString();
    //console.log('Encrypted text:', encryptedText);
    return encryptedText;
  }

  supplierTypeChange(event:any){
    //console.log(event);
    if(event == "Airport Rep"){
      let filterrow:any = [];
      this.transferlistcopy = this.transferlist;
      filterrow = this.transferlist.filter((item: { transfertype: string; })=> item.transfertype != "INTERHOTEL");
      this.transferlist = filterrow;
      this.transferPageIndex = 0;
    }
    else{
      this.transferlist = this.transferlistcopy;
    }
  }

  formatTime(timeString: string): string {
    return timeString.substring(0, 5); // Extracts 'HH:mm'
  }

  getTransferRowClass(item: any){
    let className = "";
    if(this.appClient == "RoyalPark"){
      if(item.assign_status == 1){ // Pending
        //className = "pending_row";
      }
      else if(item.assign_status == "Assigned"){ // Assigned
        //className = "assigned_row";
      }
      else if(item.assign_status == "Confirmed"){ // Confirmed
        className = "confirmed_row";
      }
      else if(item.assign_status == 5){ // Rejected
        className = "rejected_row";
      }
    }
    else if(this.appClient != "RoyalPark"){
      if( item.assign_status == 1){
        className = "pink_row";
      }
    }

    return className;
  }

}